<script lang="ts">
    import type { DiceRoll } from "../../../lib/dice_rolls";
    import CalculatorNumberResult from "../CalculatorNumberResult.svelte";

    export let roll: DiceRoll | null = null;

    let min: number;
    let avg: number;
    let max: number;
    $: if (roll != null) {
        min = roll.min();
        avg = roll.average();
        max = roll.max();
    }
</script>

<div class="center-contents-h">
    <div class="three-number-grid full-w">
        <div>Min</div>
        <div>Avg</div>
        <div>Max</div>
        <CalculatorNumberResult number={min} color={"blue"} />
        <CalculatorNumberResult number={avg} color={"blue"} />
        <CalculatorNumberResult number={max} color={"blue"} />
    </div>
</div>